import React, { useEffect } from 'react';
//import { licitacionesPublicas } from '../../json/licitacionesPublicas2023';
import '../LicitacionesPublicas/licitacionesPublicas.css';


  const DetalleLicitacion2026 = () => {
        useEffect(() => {
          window.scrollTo(0, 0);
  },[]); 

  return (
    <div className="container">
        <div className="row">
              <div> 
                  <h3 className="title">Licitaciones Públicas 2026</h3>
                  <hr className="hr-gob" />
              </div>

         <div style={{ width: "100%" }}>
            <table className="table table-striped table-bordered">
                      <tr>
                        <th scope="col" colspan="2"><div className="detalle_nombreLicitacion" style={{ width: "380px" }}>Licitación Pública No.</div></th>
                        <th scope="col"><div className="detalle_nombreColumna">Convocatoria</div></th>
                        <th scope="col"><div className="detalle_nombreColumna">Bases</div></th>
                        <th scope="col"><div className="detalle_nombreColumna">Junta de aclaraciones</div></th>
                        <th scope="col"><div className="detalle_nombreColumna">Presentación y Apertura</div></th>
                        <th scope="col"><div className="detalle_nombreColumna">Fallo</div></th>
                      </tr>
            </table>
         </div>
            
            <div className="contenedor-tabla">
            <table className="table table-striped table-bordered tabla-elementos">
                    <tbody>
                          <tr>
                              <th><div className="detalle_i"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row"><div className="detalle_Licitacion">SEDIFH-Inv3pCJGA/SA Auditoría Externa 26-1</div></th>
                              <td><div className="div-elementos">
                                 {/*   <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/Conv._Lic_Estatal_DIFN1_2025.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>  */}
                                </div></td>
                              <td><div className="div-elementos">
                                    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/1._Bases_Inv_Adq_26-1_AUDITORIA_EXTERNA_JUNTA.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div></td>
                              <td><div className="div-elementos">
                                    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/2_Jta_Aclarac_inv3p_26_1_JGA.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> 
                                </div></td>
                              <td><div className="div-elementos">
                                 {/*   <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/3_APERTURA_DIFN1-2025_ARR_VEHICULAR.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> */}
                                </div></td>
                              <td><div className="div-elementos">
                                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/5_Fallo_DIFN1-2025_ARR_VEHICULAR.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> */}
                                </div></td>
                          </tr>
                          <tr>
                              <th><div className="detalle_i"><i className="bi bi-file-earmark-pdf-fill"></i></div></th>
                              <th scope="row"><div className="detalle_Licitacion">SEDIFH-Inv3pSSA Auditoría Externa 26-2</div></th>
                              <td><div className="div-elementos">
                                 {/*   <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/Conv._Lic_Estatal_DIFN1_2025.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>  */}
                                </div></td>
                              <td><div className="div-elementos">
                                    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/1._Bases_Inv_Adq_26-2_AUDITORIA_EXTERNA_SISTEMA.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a>
                                </div></td>
                              <td><div className="div-elementos">
                                    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/2_Jta_Aclarac_inv3p_26_2_DIFH.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> 
                                </div></td>
                              <td><div className="div-elementos">
                                 {/*   <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/3_APERTURA_DIFN1-2025_ARR_VEHICULAR.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> */}
                                </div></td>
                              <td><div className="div-elementos">
                                {/*    <a href="http://dif.hidalgo.gob.mx/pdf/licitaciones_publicas/2026/5_Fallo_DIFN1-2025_ARR_VEHICULAR.pdf" target="_blank" rel="noopener noreferrer"><button class="btn btn-default btn-pdf" type="button">PDF</button></a> */}
                                </div></td>
                          </tr>
                  </tbody>
              </table>
          </div>         
       </div>
    </div>
    )
}

export default DetalleLicitacion2026